import formInputClasses from "./FormInput.module.css";

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// AD-188: helper text sits under the field in the design, where Mantine puts it above.
export const formFieldProps = {
    classNames: formInputClasses,
    inputWrapperOrder: ['label', 'input', 'description', 'error'],
    radius: 8,
};
